
export const initialUrl = '/'; // this url will open first
